<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb
      :items="items"
      :canAddNew="!canAdd"
      search_route="/reviews/add"
      :search_title="$t('breadcrumb.reviews.add')"
      icon="fa-plus"
    />
    <!-- End Breadcrumb -->
    <!-- <main-filter
      @getResult="setRows"
      categories
      code
      price
      withCategory
      withSizes
      withColors
    /> -->
    <MainLoader v-if="loading"></MainLoader>
    <div class="fadeIn" v-else>
      <!-- Start Main Section -->

      <main>
        <v-data-table
          class="elevation-1 thumb diff_table"
          :headers="headers"
          :items="reviews"
          :search="search"
          :custom-filter="helper_filterSearch"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- Select no data State -->
          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>
          <!-- index -->
          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:[`item.client_name`]="{ item }">
            <p>{{ item.client_name }}</p>
          </template>
          <template v-slot:[`item.career`]="{ item }">
            <p>{{ item.career }}</p>
          </template>
          <template v-slot:[`item.content`]="{ item }">
            <p>{{ item.content }}</p>
          </template>
          <!-- avatar -->
          <!-- <template v-slot:[`item.image`]="{ item }">
              <img @click="show_model_1" class="image" :src="item.image" />
            </template> -->

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions">
              <!-- <v-icon class="show" small @click="showItem(item)">
              fal fa-eye
            </v-icon> -->
              <v-icon
                class="edit"
                v-if="!canEdit"
                small
                @click="editItem(item)"
              >
                fal fa-edit
              </v-icon>
              <v-icon
                class="delete"
                v-if="!canDelete"
                small
                @click="deleteItem(item.id)"
              >
                fal fa-trash
              </v-icon>
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <h3 class="title table-title">
              {{ $t("breadcrumb.reviews.title") }}
            </h3>
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Add & Delete -->
            <v-row>
              <v-col cols="12" sm="8"></v-col>
            </v-row>
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
        <!-- End Statistics Card-->
        <!-- <div class=" d-flex flex-wrap  justify-content-center">
              <div class="col-6 py-0" v-for=" client in reviews" :key="client.id">
                  <ClientCard :cardData="client" @deleteThis="deleteItem"/>
              </div>
          </div>
        <div v-if="!reviews.length">
          <h3>لايوجد بيانات </h3>
          <img  src="@/assets/images/icons/404/7.svg"/>
        </div> -->
      </main>

      <!-- Delete dialog -->
      <!-- <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5 justify-center">
              {{ $t('table.deletedialog.areYouSure') }}
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#fff" @click="deleteItemConfirm">
                {{ $t('table.deletedialog.ok') }}
              </v-btn>
              <v-btn color="#fff" @click="dialogDelete = false">
                {{ $t('table.deletedialog.cancel') }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container tw-text-center mb-5 d-flex justify-content-end"
        >
          <v-pagination
            color="primary"
            v-model="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
      <!-- End Pagination -->
    </div>
    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MainFilter from "../../../components/Filters/MainFilter.vue";

export default {
  components: {
    MainFilter,
    ClientCard: () => import("../../../components/UI/cards/Client.vue"),
  },
  data() {
    return {
      reviews: [],
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.reviews.title"),
          disabled: false,
          href: "/reviews/show-all",
        },
        {
          text: this.$t("breadcrumb.reviews.all"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 15,
      },
      showItems: [
        {
          id: 1,
          value: 5,
        },
        {
          id: 2,
          value: 10,
        },
        {
          id: 1,
          value: 20,
        },
      ],

      // ========== Loding
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "العميل ",
            align: "center",
            value: "client_name",
            sortable: true,
          },

          {
            text: " الوظيفة ",
            align: "center",
            value: "career",
            sortable: true,
          },
          {
            text: "المحتوي",
            align: "center",
            value: "content",
            sortable: true,
          },
          {
            text: "التحكم",
            align: "center",
            value: "actions",
            sortable: true,
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },

  methods: {
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/reviews/add" });
    },
    // showItem(item) {
    //   this.$router.push({ path: '/reviews/show/' + item.id })
    // },
    editItem(item) {
      this.$router.push({ path: "/reviews/edit/" + item.id });
    },

    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `review/${this.itemtoDelete}`,
      })
        .then(() => {
          this.reviews = this.reviews.filter((item) => {
            return item.id != this.itemtoDelete;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      // const params = new URLSearchParams()
      // params.append('page', this.paginations.current_page)
      // params.append('keyword', e?.searchInput ? e.searchInput : '')
      // params.append('code', e?.code ? e.code : '')
      // params.append('from_price', e?.start_price ? e.start_price : '')
      // params.append('to_price', e?.end_price ? e.end_price : '')
      // params.append(
      //   'category_id',
      //   e?.selectedCategory ? e.selectedCategory.id : '',
      // )
      // params.append('size', e?.size ? e.size.id : '')
      // params.append('color', e?.color ? e.color.id : '')

      // if (e?.feature) {
      //   e.feature.map((el, index) => {
      //     params.append(`features[${index}]`, el.id)
      //   })
      // }
      this.axios({
        method: "GET",
        url: "review",
        // params: params,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;
          this.reviews = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },

  // ======= hooks
  created() {
    this.canEdit = this.$permission.allowed("reviews/edit/");
    this.canDelete = this.$permission.allowed("reviews/delete");
    this.canAdd = this.$permission.allowed("reviews/add");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: 120px;
  img {
    width: 100%;
  }
}
</style>
